import React from "react";
import PropTypes from "prop-types";
import styles from "./StatusRadioGroup.module.css";
import StatusRadioButton from "../StatusRadioButton";

/**
 * Interactive component. A list of radio button options that allow the user to select a status.
 */
export function StatusRadioGroup({
  orientation,
  options,
  currentStatus,
  setCurrentStatus,
  label,
}) {
  return (
    <fieldset className={styles.container}>
      <legend
        style={{
          float: orientation === "horizontal" ? "left" : null,
        }}
        className={styles.label}
      >
        {label}
      </legend>
      {/* Fix key mapping for proper uniqueness */}
      {options.map(({ optionTitle, optionColor, optionIcon }) => (
        <div className={styles.option} key={optionTitle}> {/* Moved key out of the list so it generates uniquely each time */}
          <StatusRadioButton
            // key={index}
            color={optionColor}
            value={optionTitle}
            icon={optionIcon}
            currentStatus={currentStatus}
            setCurrentStatus={() => setCurrentStatus(optionTitle)}
          />
        </div>
      ))}
    </fieldset>
  );
}

StatusRadioGroup.propTypes = {
  /**
   * Determines the orientation of the radio group.
   * Defaults to vertical.
   */
  orientation: PropTypes.oneOf(["vertical", "horizontal"]),
  /**
   * An array of the possible status options with their background color when selected.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      optionTitle: PropTypes.string,
      optionColor: PropTypes.oneOf(["blue", "green", "red"]),
      /**
       * Optional
       */
      optionIcon: PropTypes.element,
    })
  ),
  /**
   * The value of the currently selected status.
   */
  currentStatus: PropTypes.string,
  /**
   * Function that fires when clicked.
   */
  setCurrentStatus: PropTypes.func,
  /**
   * Label for radio group.
   */
  label: PropTypes.string,
};
